import { render, staticRenderFns } from "./MasterCategories.vue?vue&type=template&id=0f5b474a&scoped=true"
import script from "./MasterCategories.vue?vue&type=script&lang=ts"
export * from "./MasterCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b474a",
  null
  
)

export default component.exports